// Admin product list — click a `[data-editable]` cell to edit it in place.
// Text/number/select cells hold a hidden shadow input/select next to their
// display span (both server-rendered, so no client-side option-building);
// a click reveals the input, a blur elsewhere saves it (or does nothing if
// unchanged), Escape reverts. Boolean (visibility) cells have no shadow
// input — a click just toggles and saves immediately, there's no
// intermediate value to type.
function showCellError(cell, message) {
    cell.classList.add('cell-error');
    cell.title = message;
    setTimeout(() => {
        cell.classList.remove('cell-error');
        cell.removeAttribute('title');
    }, 3000);
}

async function saveField(cell, field, value) {
    const row = cell.closest('[data-product-id]');
    const productId = row?.dataset.productId;
    const csrf = row?.dataset.csrf;
    if (!productId || !csrf) return;

    cell.classList.add('is-saving');

    let response;
    let data;
    try {
        response = await fetch(`/admin/product/${productId}/field`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ field, value, _token: csrf }),
        });
        data = await response.json();
    } catch {
        cell.classList.remove('is-saving');
        showCellError(cell, 'Erreur réseau.');
        return;
    }

    cell.classList.remove('is-saving');

    if (!response.ok) {
        showCellError(cell, data.error || 'Erreur.');
        return;
    }

    const display = cell.querySelector('[data-cell-display]');
    if (display) {
        display.innerHTML = data.html;
    } else {
        cell.innerHTML = data.html;
    }
}

function openCell(cell) {
    const input = cell.querySelector('[data-cell-input]');
    const display = cell.querySelector('[data-cell-display]');
    if (!input || !display || !input.hidden) return;

    // Lock the input to the display span's own rendered width (measured
    // while it's still visible) rather than letting the column resize to
    // fit the input — a <select> gets a little extra room for its native
    // dropdown arrow, which the plain text never needed.
    const width = display.getBoundingClientRect().width;
    const buffer = input.tagName === 'SELECT' ? 24 : 4;
    input.style.width = `${Math.ceil(width + buffer)}px`;

    cell.dataset.originalValue = input.value;
    cell.classList.add('is-editing');
    display.hidden = true;
    input.hidden = false;
    input.focus();
    input.select?.();
}

function commitCell(cell, input) {
    const display = cell.querySelector('[data-cell-display]');
    cell.classList.remove('is-editing');
    input.hidden = true;
    if (display) display.hidden = false;

    const originalValue = cell.dataset.originalValue ?? '';
    if (input.value === originalValue) return;

    saveField(cell, cell.dataset.field, input.value);
}

export default function initInlineEdit() {
    document.addEventListener('click', (e) => {
        const cell = e.target.closest('[data-editable]');
        if (!cell) return;

        if (cell.dataset.type === 'boolean') {
            e.preventDefault();
            const badge = cell.querySelector('.badge');
            const currentlyVisible = badge?.classList.contains('bg-success') ?? false;
            saveField(cell, cell.dataset.field, !currentlyVisible);
            return;
        }

        openCell(cell);
    });

    // blur doesn't bubble — listen on the capture phase instead.
    document.addEventListener('blur', (e) => {
        if (!(e.target instanceof HTMLElement)) return;
        const input = e.target.closest('[data-cell-input]');
        if (!input || input.hidden) return;

        const cell = input.closest('[data-editable]');
        if (cell) commitCell(cell, input);
    }, true);

    document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;

        const input = e.target.closest('[data-cell-input]');
        if (!input) return;

        const cell = input.closest('[data-editable]');
        input.value = cell?.dataset.originalValue ?? input.value;
        input.blur();
    });
}
